module.exports = __webpack_public_path__ + "img/volume-bar.62c4838f.svg";